module.exports = __webpack_public_path__ + "img/bosspack_dg_k.c2c6e662.png";